/* ================================================================
   Pack [Obrador] Builder — Plan 1.6 (visible-grid, stepper-driven)

   Major refactor: the modal-driven "Editar" picker is gone. All
   eligible products are rendered inline as cards; customers add or
   remove via `+` / stepper.

   Slot-fill model preserved (state.slotFills[slot_id] = [handle, ...])
   so the cart line-item contract is unchanged: each fill becomes its
   own line with properties { _glend_pack, _glend_pack_label,
   _glend_pack_slot }.

   Owner: fe-dev
   ================================================================ */

(function () {
  'use strict';

  // --- Inline SVG sprite map for trust-signal icons (mirrors Cookie Pack) ---
  var TRUST_ICONS = {
    gluten_free:
      '<svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="m7.068 12.352-4.552 3.154-.57-.822 4.553-3.154zm10.455-7.03L12.97 8.477l-.57-.822L16.953 4.5zM9.5 16.51V7.488a.5.5 0 0 1 1 0v9.022a.5.5 0 0 1-1 0m2.15-10.34c.415-1.78-.516-3.193-1.233-3.81a.5.5 0 0 0-.697.043C8.505 3.747 8.24 5.056 8.467 6.157l.98-.203c-.136-.658-.043-1.5.67-2.462.428.55.799 1.423.56 2.45z"/><path d="M9.24 5.58a4.1 4.1 0 0 0-2.14-.93.5.5 0 0 0-.552.428c-.183 1.3-.01 2.398.47 3.183l.853-.522c-.27-.44-.436-1.105-.386-1.99.358.107.757.294 1.104.59.505.433.926 1.119.926 2.225h1c0-1.401-.551-2.364-1.276-2.984"/><path d="M10.777 5.77a4.1 4.1 0 0 1 2.139-.93.5.5 0 0 1 .552.428c.183 1.3.01 2.399-.47 3.183l-.853-.522c.27-.44.436-1.105.386-1.99a3.1 3.1 0 0 0-1.104.591c-.505.432-.926 1.118-.926 2.224h-1c0-1.401.551-2.364 1.276-2.983"/><path d="M11.131 8.036a4.1 4.1 0 0 1 2.235-.669.5.5 0 0 1 .498.49c.026 1.314-.276 2.383-.846 3.105l-.785-.62c.32-.405.564-1.045.62-1.93a3.1 3.1 0 0 0-1.167.456c-.552.369-1.052 1-1.183 2.098l-.993-.119c.167-1.391.828-2.281 1.621-2.81"/><path d="M8.784 8.016a4.1 4.1 0 0 0-2.258-.584.5.5 0 0 0-.479.509c.023 1.313.366 2.37.962 3.07l.761-.649c-.335-.393-.603-1.023-.692-1.905.37.05.794.173 1.183.411.566.348 1.089.96 1.262 2.052l.988-.156c-.22-1.384-.914-2.249-1.727-2.748"/><path d="M10.449 12.182c-1.156-1.952-3.177-2.102-4.216-1.867a.5.5 0 0 0-.38.587c.261 1.296.822 2.177 1.523 2.742.695.56 1.488.776 2.167.818l.062-.998a2.8 2.8 0 0 1-1.602-.6c-.41-.33-.792-.84-1.037-1.634.81-.02 1.925.283 2.622 1.461z"/><path d="M9.505 12.182c1.155-1.952 3.176-2.102 4.216-1.867a.5.5 0 0 1 .38.587c-.26 1.291-.806 2.176-1.492 2.747a3.7 3.7 0 0 1-2.148.833l-.062-.998a2.7 2.7 0 0 0 1.57-.604c.401-.334.776-.85 1.02-1.65-.81-.02-1.926.282-2.623 1.461z"/><path fill-rule="evenodd" d="M10 18.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17m0 1a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19"/></svg>',
    dedicated:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>',
    handmade:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 11V5a1.5 1.5 0 0 1 3 0v5"/><path d="M12 10V4a1.5 1.5 0 0 1 3 0v7"/><path d="M15 10V6a1.5 1.5 0 0 1 3 0v9a6 6 0 0 1-6 6h-1c-2 0-3-1-4-2l-3-5c-.6-1 .2-2 1-1.5l3 1.5"/></svg>',
    delivery:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>',
    chef_hat:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 14a3.5 3.5 0 0 1-1.5-6.66A4 4 0 0 1 12 5a4 4 0 0 1 6.5 2.34A3.5 3.5 0 0 1 17 14"/><path d="M7 14h10v5a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z"/><path d="M10 14v6"/><path d="M14 14v6"/></svg>',
    assortment:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="7" cy="7" r="3"/><circle cx="17" cy="7" r="3"/><circle cx="7" cy="17" r="3"/><circle cx="17" cy="17" r="3"/></svg>',
    barcelona:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s7-7 7-12a7 7 0 0 0-14 0c0 5 7 12 7 12z"/><circle cx="12" cy="10" r="2.4"/></svg>',
    sparkle:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 3l1.6 4.4L16 9l-4.4 1.6L10 15l-1.6-4.4L4 9l4.4-1.6z"/><path d="M18 14l.7 1.8L20.5 16.5l-1.8.7L18 19l-.7-1.8L15.5 16.5l1.8-.7z"/></svg>',
    calendar:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 9h18"/><path d="M8 3v4"/><path d="M16 3v4"/></svg>',
    pause:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M10 9v6"/><path d="M14 9v6"/></svg>',
  };

  function formatEur(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '0,00 €';
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function templateReplace(str, params) {
    if (!str) return '';
    var out = str;
    Object.keys(params).forEach(function (k) {
      var v = String(params[k]);
      out = out.replace(new RegExp('\\{\\{\\s*' + k + '\\s*\\}\\}', 'g'), v);
      out = out.replace('__' + k.toUpperCase() + '__', v);
    });
    return out;
  }

  class PackObradorBuilder {
    constructor(root) {
      this.root = root;
      this.productId = root.dataset.productId;
      this.productHandle = root.dataset.productHandle;
      this.obradorHandle = root.dataset.obradorHandle;
      this.obradorName = root.dataset.obradorName || '';
      this.spGroupId = root.dataset.spGroupId || '';
      this.spDefaultPlanId = root.dataset.spDefaultPlanId || '';

      try { this.sorprendeme = JSON.parse(root.dataset.sorprendeme || '{}'); }
      catch (_) { this.sorprendeme = {}; }

      // Card keys that resolve to a published product, computed in Liquid with
      // the same all_products test the card grid uses. Both the slot eligible
      // lists and the Sorprendeme picks are hand-maintained metafields that do
      // NOT track product status, so they are intersected against this before
      // anything counts as fillable. Empty set = attribute missing (older
      // render); fall back to trusting the metafields rather than emptying the
      // builder. See the AVAILABILITY comment in pack-obrador-builder.liquid.
      var availableRaw = (root.dataset.availableKeys || '').split('~~');
      this.availableKeys = new Set();
      availableRaw.forEach((k) => {
        var t = (k || '').trim();
        if (t) this.availableKeys.add(t.normalize ? t.normalize('NFC') : t);
      });

      try { this.strings = JSON.parse(root.dataset.strings || '{}'); }
      catch (_) { this.strings = {}; }

      this.state = {
        variantId: root.dataset.defaultVariantId,
        tierName: '',
        tierHandle: '',
        tierIndex: 0,
        slots: [],
        mode: (root.dataset.defaultMode || 'configura'),
        // { slot_id: [handle, handle, ...] } — LIFO removal
        slotFills: {},
        isSubmitting: false,
        isComplete: false,
        isEditing: false,
      };

      // handle -> { id, title, image, vendor, variantId, price }
      this.productCache = new Map();
      this.toastTimer = null;
      // When re-opened via the cart "Editar" action, holds the pack instance
      // being edited so re-submit replaces it instead of duplicating it.
      this.editContext = null;

      this.bindElements();
      this.setupPreviewBannerOffset();
      this.seedProductCacheFromDOM();
      this.syncTierLabels();
      this.renderTrustIcons();
      this.bindEvents();
      this.initFromDefaultTier();
    }

    /* --------------------------------------------------------------
       Element refs
       -------------------------------------------------------------- */
    bindElements() {
      this.tierButtons = Array.from(this.root.querySelectorAll('.pob-tier'));
      this.modeButtons = Array.from(this.root.querySelectorAll('.pob-mode__card'));
      this.gridGroupsRoot = this.root.querySelector('[data-grid-groups]');
      this.capacityRows = this.root.querySelector('[data-capacity-rows]');
      this.capacityStatus = this.root.querySelector('[data-capacity-status]');

      this.ctas = Array.from(this.root.querySelectorAll('[data-add-to-cart]'));
      this.ctaTexts = Array.from(this.root.querySelectorAll('[data-cta-text]'));
      this.ctaSpinners = Array.from(this.root.querySelectorAll('[data-cta-spinner]'));

      this.summaryTotal = this.root.querySelector('[data-summary-total]');
      this.onetimePrice = this.root.querySelector('[data-onetime-price]');
      this.summaryShipping = this.root.querySelector('[data-summary-shipping]');
      this.summaryHelperCancel = this.root.querySelector('[data-summary-helper-cancel]');
      // Subscription picker price spans — variant.price on the pack is a €0
      // placeholder (pack pricing is computed dynamically here), so the Liquid
      // render seeds these with €0,00 and we mirror the live pack total.
      this.subPickStrike = document.querySelector('.sub-pick__price-strike');
      this.subPickDiscounted = document.querySelector('[data-sub-price-discounted]');
      this.subPickOptions = Array.from(document.querySelectorAll('[data-sub-select] option'));

      this.mobileProgress = this.root.querySelector('[data-mobile-progress]');
      this.mobileTotal = this.root.querySelector('[data-mobile-total]');
      this.mobileCapacity = this.root.querySelector('[data-mobile-capacity]');

      this.toastRegion = this.root.querySelector('[data-toast-region]');
      this.trustSlots = Array.from(document.querySelectorAll('[data-trust-icon]'));
    }

    /* --------------------------------------------------------------
       Preview-banner offset — lift the mobile bar above any other
       fixed bottom overlay (e.g. Shopify's theme-preview banner that
       appears on unpublished-theme previews). Sets `--pob-bottom-offset`
       on `this.root` to the banner's measured height; CSS consumes it
       on .pob-mobile-bar, the editorial-section page clearance, and
       the toast region. No banner = var stays unset, CSS falls back to
       0px — production behaviour is unchanged.
       -------------------------------------------------------------- */
    setupPreviewBannerOffset() {
      var self = this;

      function findPreviewBanner() {
        // Shopify has used a few different selectors over the years; try
        // the most specific first, then fall back to a generic detect.
        var candidates = [
          'iframe#admin-bar-iframe',
          '#preview-bar-iframe',
          '.shopify-preview-bar',
          '[data-shopify-preview-bar]',
        ];
        for (var i = 0; i < candidates.length; i++) {
          var el = document.querySelector(candidates[i]);
          if (el) return el;
        }
        // Generic fallback: any fixed-bottom iframe whose src points at
        // the storefront preview tooling. Cheap — only runs once per call.
        var iframes = document.querySelectorAll('iframe');
        for (var j = 0; j < iframes.length; j++) {
          var iframe = iframes[j];
          var cs = window.getComputedStyle(iframe);
          if (cs.position !== 'fixed') continue;
          var bottom = parseFloat(cs.bottom);
          if (isNaN(bottom) || bottom > 50) continue;
          var src = iframe.getAttribute('src') || '';
          if (/preview|admin|storefront/.test(src)) return iframe;
        }
        return null;
      }

      function applyOffset() {
        var banner = findPreviewBanner();
        if (!banner) {
          self.root.style.removeProperty('--pob-bottom-offset');
          return;
        }
        var rect = banner.getBoundingClientRect();
        if (rect.height > 0) {
          self.root.style.setProperty('--pob-bottom-offset', rect.height + 'px');
        }
      }

      // Run once now (banner may already be in DOM), once after window.load
      // (the banner iframe loads async), and on viewport changes.
      applyOffset();
      if (document.readyState === 'complete') {
        setTimeout(applyOffset, 50);
      } else {
        window.addEventListener('load', function () {
          setTimeout(applyOffset, 50);
        });
      }
      window.addEventListener('resize', applyOffset);
    }

    /* --------------------------------------------------------------
       Seed cache from Liquid-rendered card data-* (no async needed)
       -------------------------------------------------------------- */
    seedProductCacheFromDOM() {
      var cards = this.root.querySelectorAll('[data-product-card]');
      cards.forEach((card) => {
        var cardKey = card.dataset.cardKey || card.dataset.productHandle;
        if (!cardKey || this.productCache.has(cardKey)) return;
        this.productCache.set(cardKey, {
          id: card.dataset.productId,
          handle: card.dataset.productHandle,
          title: card.dataset.productTitle || cardKey,
          image: card.dataset.productImage || '',
          vendor: card.dataset.productVendor || '',
          variantId: card.dataset.productVariantId,
          variantTitle: card.dataset.variantTitle || '',
          price: parseInt(card.dataset.productPrice, 10) || 0,
        });
      });
    }

    /* --------------------------------------------------------------
       Trust icons — inject SVG via data-trust-icon key
       -------------------------------------------------------------- */
    renderTrustIcons() {
      this.trustSlots.forEach((slot) => {
        var key = slot.dataset.trustIcon;
        var svg = TRUST_ICONS[key] || TRUST_ICONS.chef_hat;
        slot.innerHTML = svg;
      });
    }

    /* --------------------------------------------------------------
       Events
       -------------------------------------------------------------- */
    bindEvents() {
      // Tier change
      this.tierButtons.forEach((btn) =>
        btn.addEventListener('click', () => this.handleTierChange(btn))
      );

      // Mode change
      this.modeButtons.forEach((btn) =>
        btn.addEventListener('click', () => this.handleModeChange(btn))
      );

      // Stepper / `+` delegation on the grid
      if (this.gridGroupsRoot) {
        this.gridGroupsRoot.addEventListener('click', (e) => {
          var actionEl = e.target.closest('[data-action]');
          if (!actionEl) return;
          var card = actionEl.closest('[data-product-card]');
          if (!card) return;
          var action = actionEl.dataset.action;
          if (action === 'increment') {
            this.handleStepperIncrement(card);
          } else if (action === 'decrement') {
            this.handleStepperDecrement(card);
          }
        });
      }

      // CTA — desktop + mobile both wired
      this.ctas.forEach((cta) =>
        cta.addEventListener('click', () => this.handleAddToCart())
      );

      // Listen for subscription-mode changes so we can update the discount preview.
      var section = this.root.closest('section') || document;
      section.addEventListener('change', (e) => {
        if (e.target && e.target.matches('[data-sub-radio]')) {
          this.updateSummary();
        }
      });
      var select = section.querySelector('[data-sub-select]');
      if (select) {
        select.addEventListener('change', () => this.updateSummary());
      }
    }

    /* --------------------------------------------------------------
       Init from default tier
       -------------------------------------------------------------- */
    initFromDefaultTier() {
      var editCtx = this.readEditContext();
      if (editCtx && this.applyEditContext(editCtx)) {
        this.renderAll();
        return;
      }
      var defaultBtn =
        this.root.querySelector('.pob-tier--selected') || this.tierButtons[0];
      if (defaultBtn) this.applyTier(defaultBtn, { skipMode: true });
      this.renderCapacityRows();
      this.applyMode(this.state.mode);
      // Guard: if the curated "sorprendeme" default produced no fills (missing or
      // empty pack_sorprendeme data for this tier), fall back to manual so we never
      // land on an empty pack with a disabled CTA.
      // Widened 2026-08-25: was "no fills at all". topUpSlots() now closes any
      // gap the curated list leaves, so reaching here incomplete means a slot's
      // pool is genuinely empty. Landing on a pre-filled pack with a disabled
      // CTA is the exact dead-end the June 2026 default-mode fix removed, so
      // hand the shopper the manual builder instead of a stuck one.
      if (this.state.mode === 'sorprendeme' && !this.allSlotsFilled()) {
        this.applyMode('configura');
      }
      this.renderAll();
    }

    /* --------------------------------------------------------------
       Edit mode — restore a pack handed over by the cart "Editar" action
       -------------------------------------------------------------- */
    readEditContext() {
      var raw = null;
      try {
        raw = sessionStorage.getItem('glend_pack_edit');
        if (raw) sessionStorage.removeItem('glend_pack_edit');
      } catch (_) {
        return null;
      }
      if (!raw) return null;
      try {
        var ctx = JSON.parse(raw);
        if (ctx && ctx.slotFills && typeof ctx.slotFills === 'object') return ctx;
      } catch (_) {}
      return null;
    }

    /* Normalize tier/slot labels for round-trip comparison. The cart API
       can return strings in NFD form (e.g. ñ as `n` + combining tilde)
       while Liquid-rendered data-* attributes are NFC (precomposed ñ).
       Strict `===` then silently fails. NFC + trim covers both. */
    normalizeLabel(s) {
      var str = (s == null ? '' : String(s));
      if (str.normalize) str = str.normalize('NFC');
      return str.trim();
    }

    applyEditContext(ctx) {
      var self = this;
      var wantTier = this.normalizeLabel(ctx.tierName);

      // Pick the tier the pack was built on — match by name (normalized to
      // handle NFC/NFD differences in characters like ñ), fall back to default.
      var tierBtn = null;
      if (wantTier) {
        tierBtn = this.tierButtons.filter(function (b) {
          return self.normalizeLabel(b.dataset.tierName) === wantTier;
        })[0];
      }
      if (!tierBtn) {
        tierBtn = this.root.querySelector('.pob-tier--selected') || this.tierButtons[0];
      }
      if (!tierBtn) return false;

      this.applyTier(tierBtn, { skipMode: true });
      this.renderCapacityRows();
      this.applyMode('configura');

      // Rebuild slotFills from the stashed pack contents. A handle is placed
      // into the slot matching its label (capacity + eligibility checked);
      // if that fails, into any eligible slot with room. Unknown / unavailable
      // products are dropped. Slot labels are normalized the same way as
      // tier names so round-tripped Unicode (ñ, accents) still matches.
      var dropped = 0;

      // Resolve a stashed key against a slot's eligible list, tolerating
      // variant-pinned handles: exact match first, then parent-fold
      // (cardKey "muffins" -> eligible "muffins|Limon"). Returns the eligible
      // entry to store (so cart submission keeps the variant) or null. Mirrors
      // fillFromSorprendeme; see feedback_pack_slots_variant_pinned_handles.
      function resolveEligible(s, cardKey, ckParent) {
        var eligible = s.eligible_product_handles || [];
        if (eligible.indexOf(cardKey) !== -1) return cardKey;
        var vm = eligible.find(function (h) {
          return String(h || '').split('|')[0] === ckParent;
        });
        return vm || null;
      }

      Object.keys(ctx.slotFills || {}).forEach(function (slotLabel) {
        var wantSlot = self.normalizeLabel(slotLabel);
        (ctx.slotFills[slotLabel] || []).forEach(function (cardKey) {
          if (cardKey && cardKey.normalize) cardKey = cardKey.normalize('NFC');
          if (!cardKey) { dropped++; return; }
          var ckParent = cardKey.split('|')[0];

          // Prefer the slot the item was originally in (label match) with room,
          // then any eligible slot with room. Match tolerates variant-pinning.
          var slot = self.state.slots.filter(function (s) {
            return self.normalizeLabel(s.label) === wantSlot &&
              (self.state.slotFills[s.slot_id] || []).length < s.count &&
              resolveEligible(s, cardKey, ckParent) !== null;
          })[0];
          if (!slot) {
            slot = self.state.slots.filter(function (s) {
              return (self.state.slotFills[s.slot_id] || []).length < s.count &&
                resolveEligible(s, cardKey, ckParent) !== null;
            })[0];
          }
          var resolved = slot ? resolveEligible(slot, cardKey, ckParent) : null;

          // Only place items we can actually render/price (present in the grid).
          if (slot && resolved &&
              (self.productCache.has(resolved) ||
               self.productCache.has(cardKey) ||
               self.productCache.has(ckParent))) {
            self.state.slotFills[slot.slot_id].push(resolved);
          } else {
            dropped++;
          }
        });
      });

      this.state.isEditing = true;
      this.editContext = {
        packInstanceId: ctx.packInstanceId,
        sellingPlan: ctx.sellingPlan || null,
      };

      if (ctx.sellingPlan) this.preselectSubscription(ctx.sellingPlan);
      if (dropped > 0) {
        this.toast(
          this.strings.edit_dropped ||
            'Algunos productos ya no están disponibles y no se han añadido.'
        );
      }
      return true;
    }

    preselectSubscription(planId) {
      var picker = this.root.querySelector('[data-sub-pick]');
      if (!picker) return;
      var planStr = String(planId);
      var select = picker.querySelector('[data-sub-select]');
      var recurringRadio = picker.querySelector('[data-sub-card="recurring"] [data-sub-radio]');
      if (select) {
        var hasOption = Array.prototype.some.call(select.options, function (o) {
          return o.value === planStr;
        });
        if (hasOption) {
          select.value = planStr;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      if (recurringRadio) {
        recurringRadio.checked = true;
        recurringRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    applyTier(btn, opts) {
      opts = opts || {};
      this.tierButtons.forEach((b) => {
        var isActive = b === btn;
        b.classList.toggle('pob-tier--selected', isActive);
        b.setAttribute('aria-checked', isActive ? 'true' : 'false');
      });
      this.state.variantId = btn.dataset.variantId;
      this.state.tierHandle = btn.dataset.tierHandle;
      this.state.tierName = btn.dataset.tierName;
      this.state.tierIndex = parseInt(btn.dataset.tierIndex, 10) || 0;

      try {
        this.state.slots = JSON.parse(btn.dataset.slots || '[]');
      } catch (_) {
        this.state.slots = [];
      }

      // Drop eligible entries whose product is no longer published, so a slot's
      // pool matches the cards actually on the page. Without this a drafted
      // product stays "eligible", gets picked, counts as filled and is then
      // silently dropped at submit. A slot the obrador can no longer supply at
      // all is removed rather than left as an unfillable hole — the tier then
      // asks for fewer items and is priced on what it actually contains, which
      // keeps the page sellable instead of dead. syncTierLabels() keeps the
      // tier buttons telling the same story.
      this.state.slots = this.resolveSlots(this.state.slots);

      // Reset slotFills shape for the new tier's slot_ids
      this.state.slotFills = {};
      this.state.slots.forEach((s) => {
        this.state.slotFills[s.slot_id] = [];
      });

      if (!opts.skipMode) {
        this.renderCapacityRows();
      }
    }

    applyMode(mode) {
      this.state.mode = mode;
      this.modeButtons.forEach((b) => {
        var active = b.dataset.packMode === mode;
        b.classList.toggle('pob-mode__card--selected', active);
        b.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      if (mode === 'sorprendeme') {
        this.fillFromSorprendeme();
      } else {
        this.clearAllSlots();
      }
    }

    fillFromSorprendeme() {
      var picks = (this.sorprendeme && this.sorprendeme[this.state.tierName]) || [];
      // Walk picks in order; place each into the first slot with capacity
      // whose eligible list matches the cardKey. Match logic:
      //   1) Exact match against eligible_product_handles
      //   2) Parent-fold fallback: cardKey is a parent handle (e.g.
      //      "muffins-miniatura") but eligible has variant-pinned entries
      //      (e.g. "muffins-miniatura|Limón"). Pick the first eligible entry
      //      sharing the parent and store THAT as the resolved key so cart
      //      submission gets the variant. See feedback_pack_slots_variant_pinned_handles.
      this.state.slots.forEach((s) => { this.state.slotFills[s.slot_id] = []; });
      picks.forEach((cardKey) => {
        var ckParent = String(cardKey || '').split('|')[0];
        var matched = null;
        var resolved = cardKey;
        for (var i = 0; i < this.state.slots.length; i++) {
          var s = this.state.slots[i];
          var fills = this.state.slotFills[s.slot_id] || [];
          if (fills.length >= s.count) continue;
          var eligible = s.eligible_product_handles || [];
          if (eligible.indexOf(cardKey) !== -1) {
            matched = s;
            resolved = cardKey;
            break;
          }
          var variantMatch = eligible.find(function (h) {
            return String(h || '').split('|')[0] === ckParent;
          });
          if (variantMatch) {
            matched = s;
            resolved = variantMatch;
            break;
          }
        }
        if (matched) this.state.slotFills[matched.slot_id].push(resolved);
      });

      this.topUpSlots();
    }

    /* --------------------------------------------------------------
       Top up any slot the curated picks left short.

       pack_sorprendeme is hand-maintained and can reference a product that has
       since been drafted, or simply list fewer items than the tier needs. The
       pre-filled default exists so cold traffic never lands on a disabled CTA
       (the June 2026 fix), so a curation gap must not reintroduce one. Fill the
       remainder from the slot's own available pool, preferring items not
       already in the pack so the result still looks like a varied selection.
       -------------------------------------------------------------- */
    topUpSlots() {
      this.state.slots.forEach((slot) => {
        var fills = this.state.slotFills[slot.slot_id] || [];
        var pool = slot.eligible_product_handles || [];
        if (!pool.length) return;
        var guard = 0;
        while (fills.length < slot.count && guard < 200) {
          guard++;
          var fresh = pool.find(function (h) { return fills.indexOf(h) === -1; });
          fills.push(fresh || pool[fills.length % pool.length]);
        }
        this.state.slotFills[slot.slot_id] = fills;
      });
    }

    /* Filter each slot's pool to published products, then drop empty slots. */
    resolveSlots(slots) {
      return (slots || [])
        .map((s) => Object.assign({}, s, {
          eligible_product_handles: this.filterAvailable(s.eligible_product_handles || []),
        }))
        .filter((s) => (s.eligible_product_handles || []).length > 0);
    }

    /* --------------------------------------------------------------
       Keep every tier button honest about what it can actually deliver.

       The composition line and the product count are rendered in Liquid from
       the raw pack_slots metafield, so if a slot's whole pool has been drafted
       the button would still advertise "1 × Desayuno" and a total of 8 while
       the grid offers neither. Recompute both from the resolved slots.
       -------------------------------------------------------------- */
    syncTierLabels() {
      var self = this;
      this.tierButtons.forEach((btn) => {
        var raw;
        try { raw = JSON.parse(btn.dataset.slots || '[]'); }
        catch (_) { return; }
        var resolved = self.resolveSlots(raw);
        var total = resolved.reduce(function (a, s) { return a + s.count; }, 0);
        btn.dataset.slotTotal = String(total);

        var detail = btn.querySelector('.pob-tier__detail');
        if (detail) {
          detail.textContent = resolved
            .map(function (s) { return s.count + ' × ' + s.label; })
            .join(' · ');
        }
        var countNum = btn.querySelector('.pob-tier__count-num');
        if (countNum) countNum.textContent = String(total);
      });
    }

    /* Intersect a list of card keys with the published set. */
    filterAvailable(keys) {
      var self = this;
      if (!this.availableKeys || this.availableKeys.size === 0) return keys.slice();
      return keys.filter(function (k) {
        var t = String(k || '');
        return self.availableKeys.has(t.normalize ? t.normalize('NFC') : t);
      });
    }

    clearAllSlots() {
      this.state.slots.forEach((s) => { this.state.slotFills[s.slot_id] = []; });
    }

    _snapshotFills() {
      var snap = {};
      Object.keys(this.state.slotFills || {}).forEach((id) => {
        snap[id] = (this.state.slotFills[id] || []).slice();
      });
      return snap;
    }

    _mergeFills(previousFills) {
      this.state.slots.forEach((slot) => {
        var prior = previousFills[slot.slot_id] || [];
        var eligible = slot.eligible_product_handles || [];
        var kept = prior.filter((handle) => eligible.indexOf(handle) !== -1)
                        .slice(0, slot.count);
        this.state.slotFills[slot.slot_id] = kept;
      });
    }

    /* --------------------------------------------------------------
       Tier / mode handlers
       -------------------------------------------------------------- */
    handleTierChange(btn) {
      if (btn.classList.contains('pob-tier--selected')) return;
      var previousFills = this._snapshotFills();
      this.applyTier(btn);
      if (this.state.mode === 'sorprendeme') {
        this.applyMode('sorprendeme');
      } else {
        this._mergeFills(previousFills);
      }
      this.renderAll();
    }

    handleModeChange(btn) {
      var mode = btn.dataset.packMode;
      if (mode === this.state.mode) return;
      this.applyMode(mode);
      this.renderAll();
    }

    /* --------------------------------------------------------------
       Stepper handlers
       -------------------------------------------------------------- */
    handleStepperIncrement(card) {
      var cardKey = card.dataset.cardKey || card.dataset.productHandle;
      var slotId = card.dataset.slotId;
      var slot = this.state.slots.find((s) => s.slot_id === slotId);
      if (!slot) return;

      var fills = this.state.slotFills[slotId] || [];
      if (fills.length >= slot.count) {
        this.handleSlotFull(card, slot);
        return;
      }

      fills.push(cardKey);
      this.state.slotFills[slotId] = fills;
      this.pulseCard(card);
      this.renderAll();
    }

    handleStepperDecrement(card) {
      var cardKey = card.dataset.cardKey || card.dataset.productHandle;
      var slotId = card.dataset.slotId;
      var fills = this.state.slotFills[slotId] || [];
      // LIFO removal of the matching cardKey
      var lastIdx = -1;
      for (var i = fills.length - 1; i >= 0; i--) {
        if (fills[i] === cardKey) { lastIdx = i; break; }
      }
      if (lastIdx === -1) return;
      fills.splice(lastIdx, 1);
      this.state.slotFills[slotId] = fills;
      this.renderAll();
    }

    handleSlotFull(card, slot) {
      // Shake the card to indicate cap reached
      card.classList.remove('is-shaking');
      void card.offsetWidth;
      card.classList.add('is-shaking');
      setTimeout(() => card.classList.remove('is-shaking'), 320);

      // Toast: offer upgrade if a higher tier exists
      var nextTier = this.tierButtons[this.state.tierIndex + 1];
      var label = slot.label;
      if (nextTier) {
        var nextTierName = nextTier.dataset.tierName;
        var template = this.strings.slot_full_upgrade ||
          'Tu pack está completo de {{ label }}. Cambia a {{ next_tier }} para añadir más.';
        var msg = templateReplace(template, { label: label, next_tier: nextTierName });
        this.toast(msg);
      } else {
        var soloTemplate = this.strings.slot_full || 'Tu pack está completo de {{ label }}.';
        this.toast(templateReplace(soloTemplate, { label: label }));
      }
    }

    pulseCard(card) {
      card.classList.remove('is-pulsing');
      void card.offsetWidth;
      card.classList.add('is-pulsing');
      setTimeout(() => card.classList.remove('is-pulsing'), 240);
    }

    /* --------------------------------------------------------------
       Render: capacity dot rows (one row per slot type)
       -------------------------------------------------------------- */
    renderCapacityRows() {
      if (!this.capacityRows) return;
      var rows = '';
      this.state.slots.forEach((slot) => {
        var dotsHtml = '';
        for (var i = 0; i < slot.count; i++) {
          dotsHtml +=
            '<span class="pob-cap-dot" data-slot-id="' + slot.slot_id +
            '" data-dot-index="' + i + '" aria-hidden="true"></span>';
        }
        rows +=
          '<div class="pob-cap-row" data-cap-row="' + slot.slot_id + '">' +
            '<span class="pob-cap-row__label">' + this.escapeHtml(slot.label) + '</span>' +
            '<span class="pob-cap-row__dots">' + dotsHtml + '</span>' +
          '</div>';
      });
      this.capacityRows.innerHTML = rows;
    }

    renderCapacityDots() {
      if (!this.capacityRows) return;
      this.state.slots.forEach((slot) => {
        var fillCount = (this.state.slotFills[slot.slot_id] || []).length;
        var dots = this.capacityRows.querySelectorAll(
          '[data-cap-row="' + slot.slot_id + '"] .pob-cap-dot'
        );
        dots.forEach((dot, idx) => {
          var wasFilled = dot.classList.contains('pob-cap-dot--filled');
          var nowFilled = idx < fillCount;
          if (nowFilled && !wasFilled) {
            dot.classList.add('pob-cap-dot--filled');
          } else if (!nowFilled && wasFilled) {
            dot.classList.remove('pob-cap-dot--filled');
          }
        });
      });
    }

    /* --------------------------------------------------------------
       Render: product cards (qty badge, stepper, dimmed when slot full)
       -------------------------------------------------------------- */
    renderCards() {
      var slotMap = {};
      this.state.slots.forEach((s) => { slotMap[s.slot_id] = s; });

      // Group fills by slot to compute counts per (slot, handle)
      var fillsBySlot = this.state.slotFills;

      var allCards = this.gridGroupsRoot
        ? this.gridGroupsRoot.querySelectorAll('[data-product-card]')
        : [];

      // First pass: figure out which slots are full so we can dim non-selected
      // cards in those slots and disable their `+` buttons.
      var slotIsFull = {};
      this.state.slots.forEach((s) => {
        slotIsFull[s.slot_id] = (fillsBySlot[s.slot_id] || []).length >= s.count;
      });

      // Per-slot counter in each group header ("N de N elegidos")
      this.state.slots.forEach((s) => {
        var grp = this.gridGroupsRoot &&
          this.gridGroupsRoot.querySelector('[data-slot-group][data-slot-id="' + s.slot_id + '"]');
        if (!grp) return;
        var el = grp.querySelector('[data-slot-count-text]');
        if (!el) return;
        var filled = (fillsBySlot[s.slot_id] || []).length;
        el.textContent = filled + ' de ' + s.count + ' elegidos';
        grp.classList.toggle('is-slot-complete', filled >= s.count);
      });

      allCards.forEach((card) => {
        var cardKey = card.dataset.cardKey || card.dataset.productHandle;
        var slotId = card.dataset.slotId;
        var fills = fillsBySlot[slotId] || [];
        var qty = 0;
        for (var i = 0; i < fills.length; i++) {
          if (fills[i] === cardKey) qty++;
        }

        var badge = card.querySelector('[data-count-badge]');
        var countEl = card.querySelector('[data-count]');
        var stepper = card.querySelector('[data-stepper]');
        var stepperQty = card.querySelector('[data-stepper-qty]');
        var minusBtn = card.querySelector('[data-action="decrement"]');
        var plusInStepper = stepper && stepper.querySelector('[data-action="increment"]');
        var addBtn = card.querySelector('.pob-card__add');

        // Count badge + stepper visibility
        if (qty > 0) {
          if (badge) badge.hidden = false;
          if (countEl) countEl.textContent = String(qty);
          if (stepper) stepper.hidden = false;
          if (stepperQty) stepperQty.textContent = String(qty);
          card.classList.add('is-selected');
          card.classList.remove('is-dimmed');
        } else {
          if (badge) badge.hidden = true;
          if (stepper) stepper.hidden = true;
          card.classList.remove('is-selected');
          // Dim only if slot is full AND this card has no qty
          var dim = slotIsFull[slotId];
          card.classList.toggle('is-dimmed', !!dim);
        }

        // Enable/disable +/- buttons based on slot capacity
        var atCap = slotIsFull[slotId];
        if (addBtn) {
          addBtn.disabled = atCap && qty === 0;
          if (atCap && qty === 0) {
            var slot = slotMap[slotId];
            addBtn.title = slot ? this.tooltipForFullSlot(slot) : '';
          } else {
            addBtn.removeAttribute('title');
          }
        }
        if (plusInStepper) {
          plusInStepper.disabled = atCap;
          if (atCap) {
            var slotForBtn = slotMap[slotId];
            plusInStepper.title = slotForBtn ? this.tooltipForFullSlot(slotForBtn) : '';
          } else {
            plusInStepper.removeAttribute('title');
          }
        }
        if (minusBtn) {
          minusBtn.disabled = qty === 0;
        }
      });
    }

    tooltipForFullSlot(slot) {
      var nextTier = this.tierButtons[this.state.tierIndex + 1];
      if (nextTier) {
        var template = this.strings.slot_full_upgrade ||
          'Tu pack está completo de {{ label }}. Cambia a {{ next_tier }} para añadir más.';
        return templateReplace(template, {
          label: slot.label,
          next_tier: nextTier.dataset.tierName,
        });
      }
      var soloTemplate = this.strings.slot_full || 'Tu pack está completo de {{ label }}.';
      return templateReplace(soloTemplate, { label: slot.label });
    }

    /* --------------------------------------------------------------
       Summary + CTA
       -------------------------------------------------------------- */
    getTotalCents() {
      var sum = 0;
      this.state.slots.forEach((slot) => {
        var fills = this.state.slotFills[slot.slot_id] || [];
        fills.forEach((cardKey) => {
          var p = this.productCache.get(cardKey);
          if (p && typeof p.price === 'number') sum += p.price;
        });
      });
      return sum;
    }

    getTotalFilled() {
      var sum = 0;
      this.state.slots.forEach((s) => {
        sum += (this.state.slotFills[s.slot_id] || []).length;
      });
      return sum;
    }

    getTotalSlotCapacity() {
      return this.state.slots.reduce((a, s) => a + s.count, 0);
    }

    allSlotsFilled() {
      return this.state.slots.every((s) => {
        var fills = this.state.slotFills[s.slot_id] || [];
        // Count only fills that will actually survive handleAddToCart(), which
        // drops anything missing from productCache. Counting a fill the cart
        // will not receive is what let a pack promise 7 items and submit 6.
        var submittable = fills.filter((k) => {
          var p = this.productCache.get(k);
          return !!(p && p.variantId);
        });
        return submittable.length === s.count;
      });
    }

    updateSummary() {
      var totalCents = this.getTotalCents();
      var formatted = formatEur(totalCents);

      // Resolve subscription state first so every total-bearing surface
      // (desktop summary, mobile sticky CTA, sub-picker spans) stays in sync.
      var pct = 0;
      var sel = document.querySelector('[data-sub-select]');
      var formId = this.findProductFormId();
      var sellingPlanInput =
        (formId && document.querySelector('input[name="selling_plan"][form="' + formId + '"]')) ||
        document.querySelector('input[name="selling_plan"]');
      var isSubscribed = !!(sellingPlanInput && sellingPlanInput.value);
      if (sel && sel.options[sel.selectedIndex]) {
        var p = parseFloat(sel.options[sel.selectedIndex].dataset.pct);
        if (!Number.isNaN(p)) pct = p;
      }
      var discCents = Math.round(totalCents * (100 - pct) / 100);
      var discFormatted = formatEur(discCents);

      if (this.summaryTotal) {
        this.summaryTotal.textContent = isSubscribed ? discFormatted : formatted;
      }
      // "Compra única" label is a comparison price — always the un-discounted total.
      if (this.onetimePrice) this.onetimePrice.textContent = formatted;

      // Subscription picker: strike = full pack total; discounted = total × (1 − plan pct).
      if (this.subPickStrike) this.subPickStrike.textContent = formatted;
      if (this.subPickDiscounted) this.subPickDiscounted.textContent = discFormatted;

      if (this.mobileTotal) {
        this.mobileTotal.textContent = isSubscribed ? discFormatted : formatted;
      }
      // Each cadence <option> caches a `data-discounted` for the click-to-swap
      // logic in subscription-picker.liquid; refresh per current total so it
      // stays in sync if the user opens the select after editing the pack.
      this.subPickOptions.forEach(function (opt) {
        var p = parseFloat(opt.dataset.pct);
        if (Number.isNaN(p)) return;
        var d = Math.round(totalCents * (100 - p) / 100);
        opt.dataset.discounted = formatEur(d);
      });

      this.updateShippingHelper(totalCents);
      this.updateHelperCancel();
    }

    updateHelperCancel() {
      if (!this.summaryHelperCancel) return;
      var formId = this.findProductFormId();
      var sellingPlanInput =
        (formId && document.querySelector('input[name="selling_plan"][form="' + formId + '"]')) ||
        document.querySelector('input[name="selling_plan"]');
      var isSubscribed = !!(sellingPlanInput && sellingPlanInput.value);
      this.summaryHelperCancel.hidden = !isSubscribed;
    }

    updateShippingHelper(totalCents) {
      if (!this.summaryShipping) return;
      const filledMsg =
        this.strings.summary_free_shipping_ok || 'Envío gratis incluido';
      const alwaysMsg =
        this.strings.summary_free_shipping_always || 'Envío gratis siempre';
      this.summaryShipping.textContent = totalCents > 0 ? filledMsg : alwaysMsg;
      this.summaryShipping.classList.add('pob-summary__shipping--ok');
    }

    updateCtaState() {
      var filled = this.allSlotsFilled();
      this.ctas.forEach((c) => { c.disabled = !filled || this.state.isSubmitting; });

      if (this.state.isSubmitting) {
        this.ctaTexts.forEach((t) => {
          t.textContent = this.strings.cta_loading || 'Añadiendo';
        });
        return;
      }

      var ready = this.state.isEditing
        ? (this.strings.cta_save || 'Guardar cambios')
        : (this.strings.cta_ready || 'Añadir al carrito');
      var incomplete = this.strings.cta_incomplete || 'Completa tu pack';
      this.ctaTexts.forEach((t) => {
        t.textContent = filled ? ready : incomplete;
      });
    }

    /* --------------------------------------------------------------
       Capacity status line + mobile bar progress
       -------------------------------------------------------------- */
    updateCapacityStatus() {
      var filled = this.getTotalFilled();
      var total = this.getTotalSlotCapacity();
      var isComplete = total > 0 && filled === total;
      this.state.isComplete = isComplete;
      this.root.classList.toggle('pob--complete', isComplete);

      if (this.capacityStatus) {
        if (isComplete) {
          this.capacityStatus.textContent =
            this.strings.capacity_complete || 'Pack completo';
        } else if (filled === 0) {
          this.capacityStatus.textContent = '';
        } else {
          var template =
            this.strings.capacity_progress_template ||
            '{{ filled }} de {{ total }} productos';
          this.capacityStatus.textContent = templateReplace(template, {
            filled: filled,
            total: total,
          });
        }
      }

      if (this.mobileProgress) {
        this.mobileProgress.max = Math.max(total, 1);
        this.mobileProgress.value = filled;
      }
      if (this.mobileCapacity) {
        if (isComplete) {
          this.mobileCapacity.textContent =
            this.strings.mobile_bar_ready || 'Tu pack está listo';
        } else if (total > 0) {
          var remaining = total - filled;
          var tmpl =
            this.strings.mobile_bar_remaining_template ||
            'Te faltan {{ count }}';
          this.mobileCapacity.textContent = templateReplace(tmpl, { count: remaining });
        } else {
          this.mobileCapacity.textContent = '';
        }
      }
    }

    /* --------------------------------------------------------------
       Single render orchestrator
       -------------------------------------------------------------- */
    renderAll() {
      this.renderCards();
      this.renderCapacityDots();
      this.updateCapacityStatus();
      this.updateSummary();
      this.updateCtaState();
    }

    /* --------------------------------------------------------------
       Toast
       -------------------------------------------------------------- */
    toast(message) {
      if (!this.toastRegion) return;
      // Replace any existing toast
      this.toastRegion.innerHTML = '';
      if (this.toastTimer) clearTimeout(this.toastTimer);

      var t = document.createElement('div');
      t.className = 'pob-toast';
      t.textContent = message;
      this.toastRegion.appendChild(t);

      this.toastTimer = setTimeout(() => {
        t.classList.add('is-leaving');
        setTimeout(() => {
          if (t.parentNode) t.parentNode.removeChild(t);
        }, 240);
      }, 3000);
    }

    /* --------------------------------------------------------------
       Cart submission (line-item contract preserved verbatim)
       -------------------------------------------------------------- */
    handleAddToCart() {
      if (this.state.isSubmitting) return;
      if (!this.allSlotsFilled()) return;

      this.state.isSubmitting = true;
      this.updateCtaState();
      this.ctaSpinners.forEach((s) => { s.hidden = false; });
      this.ctas.forEach((c) => c.classList.add('is-submitting'));

      // Resolve selling_plan from subscription picker
      var formId = this.findProductFormId();
      var sellingPlanInput =
        (formId && document.querySelector('input[name="selling_plan"][form="' + formId + '"]')) ||
        document.querySelector('input[name="selling_plan"]');
      var sellingPlan =
        sellingPlanInput && sellingPlanInput.value
          ? parseInt(sellingPlanInput.value, 10)
          : null;

      var packInstanceId =
        this.obradorHandle + '-' + this.state.tierHandle + '-' + Date.now();
      var packLabel =
        'Pack ' + (this.obradorName || this.productHandle) + ' · ' + this.state.tierName;

      var items = [];
      this.state.slots.forEach((slot) => {
        var fills = this.state.slotFills[slot.slot_id] || [];
        fills.forEach((cardKey) => {
          if (!cardKey) return;
          var p = this.productCache.get(cardKey);
          if (!p || !p.variantId) return; // defensive — should be valid
          var lineItem = {
            id: parseInt(p.variantId, 10),
            quantity: 1,
            properties: {
              _glend_pack: packInstanceId,
              _glend_pack_label: packLabel,
              _glend_pack_slot: slot.label,
              _glend_pack_url: window.location.pathname,
            },
          };
          if (sellingPlan) lineItem.selling_plan = sellingPlan;
          items.push(lineItem);
        });
      });

      if (!items.length) {
        this.handleCartError(this.strings.toast_error_generic ||
          'No hemos podido añadir el pack al carrito.');
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items: items }),
      })
        .then((r) => r.json().then((d) => ({ ok: r.ok, data: d })))
        .then((result) => {
          if (!result.ok) {
            var msg =
              (result.data && (result.data.description || result.data.message)) ||
              this.strings.toast_error_generic ||
              'No hemos podido añadir el pack al carrito.';
            this.handleCartError(msg);
            return;
          }
          // Cart-update publish for non-pixel subscribers (cart-drawer, etc.).
          // Note: Meta Pixel AddToCart is NOT fired here — Shopify's web
          // pixel auto-detects each item inside the batch /cart/add.js payload
          // and fires AddToCart per item. 'pack-builder' is excluded from
          // glend-meta-pixel.js addSources to avoid double-firing against
          // Shopify's auto events.
          try {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
              var addedItems = (result.data && result.data.items) || [];
              addedItems.forEach(function (lineItem) {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'pack-builder',
                  productVariantId: lineItem.variant_id,
                  cartData: lineItem,
                });
              });
            }
          } catch (_) { /* never block the cart redirect */ }
          // Success. In edit mode, remove the pack being replaced before
          // redirecting — add-then-remove, so a failed add never loses the
          // original pack.
          if (this.state.isEditing && this.editContext && this.editContext.packInstanceId) {
            this.removeOldPack(this.editContext.packInstanceId)
              .then(function () { window.location.href = '/cart'; })
              .catch(function () { window.location.href = '/cart'; });
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(() => {
          this.handleCartError(
            this.strings.toast_error_network || 'Error de red. Inténtalo otra vez.'
          );
        });
    }

    /* --------------------------------------------------------------
       Edit mode — remove the pack instance being replaced
       -------------------------------------------------------------- */
    removeOldPack(packId) {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var updates = {};
          var matched = 0;
          (cart.items || []).forEach(function (item) {
            if (item.properties && item.properties._glend_pack === packId) {
              updates[item.key] = 0;
              matched++;
            }
          });
          if (!matched) return null;
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates }),
          });
        });
    }

    handleCartError(message) {
      this.state.isSubmitting = false;
      this.ctaSpinners.forEach((s) => { s.hidden = true; });
      this.ctas.forEach((c) => c.classList.remove('is-submitting'));
      this.updateCtaState();
      this.toast(message);
    }

    findProductFormId() {
      var section = this.root.closest('section[id^="shopify-section-"]');
      if (!section) return '';
      var sid = section.id.replace('shopify-section-', '');
      return 'product-form-' + sid;
    }

    /* --------------------------------------------------------------
       Helpers
       -------------------------------------------------------------- */
    escapeHtml(str) {
      if (str == null) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }
  }

  function init() {
    document.querySelectorAll('.pob').forEach((root) => {
      if (!root.dataset.pobInitialized) {
        new PackObradorBuilder(root);
        root.dataset.pobInitialized = '1';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
